import axios from 'axios'
import store from '../store/modules/LoginDetails';

const httpClient = axios.create({
  baseURL: `${process.env.VUE_APP_APICONNECT}`,
  timeout: 50000,
  headers: {
    'Ocp-Apim-Subscription-Key': process.env.VUE_APP_OCP_APIM_SUBSCRIPTION_KEY,
    'Authorization': "Bearer " + store.state.AkamaiToken
  },
  params: {} // params placeholder
})


export default httpClient
